module.exports = __webpack_public_path__ + "static/media/clientmanagment.8d18ee2f.jpg";